import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export default function HtmlTooltip(props) {
  if(props.title==undefined){return props.children;}
  return (
    <HtmlTooltipComponent {...props} placement={props.placement} interactive leaveDelay={50} title={<div dangerouslySetInnerHTML={{__html: props.title}}></div>} />
  );
}

const HtmlTooltipComponent = withStyles({
  tooltip: {
    border: '1px solid #dadde9',
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth:'500px',
    fontSize:'12px'
  }
})(Tooltip);
